import { readableColor } from "polished";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";

export const ResumeCourses = ({
  children,
  searchSlot,
  paginationSlot,
  id = "courses-section",
}) => {
  const theme = useTheme();
  const { lang, dictionary } = useAuth();
  return (
    <>
      <div
        className="vacio"
        style={{ backgroundColor: theme.colors.backgroundBajada }}
      ></div>
      <div style={{ backgroundColor: theme.colors.backgroundBajada }}>
        <div
          id={id}
          className="px-8 mx-auto tablet:max-w-[740px] laptop:max-w-[1124px] desktop:max-w-[1380px]"
        >
          <h1
            className="tit-color font-russo font-semibold"
            /* style={{ color: readableColor(theme.colors.backgroundBajada) }} */
            style={{ color: theme.mode === "light" ? "#44BCF9" : "#fff", fontSize:'41px' }}
          >
            {dictionary.Home.title}
          </h1>
          {/*         <p className="bajada-tit" style={theme.styles.text}>
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
          commodo ligula eget dolor.{" "}
          </p> */}
        </div>
      </div>
      <div
        className="vacio"
        style={{ backgroundColor: theme.colors.backgroundBajada }}
      ></div>
      <div
        className="wrapper fon-sec-car !py-6"
        style={{ backgroundColor: theme.colors.backgroundColorBody }}
      >
        <div className="container mx-auto max-w-[1420px] ">
          <div className="col-md-12">
            <div className="row d-flex justify-content-center flex-col">
              {searchSlot && (
                <div className="flex justify-end w-full mb-6">{searchSlot}</div>
              )}
              <div className="grid grid-cols-1 min-[700px]:grid-cols-2 laptop:grid-cols-3 min-[1380px]:grid-cols-4 gap-6 tablet:gap-8 justify-items-center w-full">
                {children}
              </div>
            </div>
            {paginationSlot && (
              <div className="flex justify-center items-center mt-10 mb-4">
                {paginationSlot}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
